module.exports = __webpack_public_path__ + "assets/a55852ef0d67638513c3514fff2f897f.png";